var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnySum)?_c('tr',{staticClass:"sum-section"},[_vm._l((_vm.emptyCellsBefore),function(i){return _c('td',{key:i})}),_vm._l((_vm.labels),function(label,index){return _c('td',{key:index + 'sum'},[(label.type === 'number' && label.sum)?_c('span',[_vm._v(" "+_vm._s(_vm.sumLabel(label))+" ")]):_c('span',[_vm._v(" - ")])])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }